import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { reservationAPI } from '../../utils/api';
import { toast } from 'react-toastify';
import './AdminReservations.css';

const AdminReservations = () => {
    const navigate = useNavigate();
    const [reservations, setReservations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState('all');

    useEffect(() => {
        fetchReservations();
    }, [filter]);

    const fetchReservations = async () => {
        try {
            const params = {};
            if (filter !== 'all') {
                params.status = filter;
            }
            const response = await reservationAPI.getAll(params);
            setReservations(response.data.data);
        } catch (error) {
            console.error('Fetch reservations error:', error);
            toast.error('Rezervasyonlar yüklenemedi');
        } finally {
            setLoading(false);
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_user');
        navigate('/admin/login');
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Bu rezervasyonu silmek istediğinizden emin misiniz?')) {
            return;
        }

        try {
            await reservationAPI.delete(id);
            toast.success('Rezervasyon silindi');
            fetchReservations();
        } catch (error) {
            console.error('Delete reservation error:', error);
            toast.error('Silme işlemi başarısız');
        }
    };

    const handleStatusChange = async (id, newStatus) => {
        try {
            await reservationAPI.updateStatus(id, newStatus);
            toast.success('Durum güncellendi');
            fetchReservations();
        } catch (error) {
            console.error('Update status error:', error);
            toast.error('Güncelleme başarısız');
        }
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('tr-TR');
    };

    const getStatusBadge = (status) => {
        const statusMap = {
            pending: { label: 'Bekliyor', class: 'status-pending' },
            confirmed: { label: 'Onaylandı', class: 'status-confirmed' },
            cancelled: { label: 'İptal', class: 'status-cancelled' },
            completed: { label: 'Tamamlandı', class: 'status-completed' }
        };
        return statusMap[status] || statusMap.pending;
    };

    if (loading) {
        return (
            <div className="admin-page">
                <div className="loading">Yükleniyor...</div>
            </div>
        );
    }

    return (
        <div className="admin-page">
            <div className="admin-header">
                <div>
                    <button onClick={() => navigate('/admin/dashboard')} className="btn-back">
                        ← Geri
                    </button>
                    <h1>📋 Rezervasyon Yönetimi</h1>
                </div>
                <button onClick={handleLogout} className="btn-logout">
                    Çıkış Yap
                </button>
            </div>

            <div className="admin-content">
                <div className="content-header">
                    <h2>Rezervasyonlar ({reservations.length})</h2>
                    <div className="filter-buttons">
                        <button
                            className={filter === 'all' ? 'active' : ''}
                            onClick={() => setFilter('all')}
                        >
                            Tümü
                        </button>
                        <button
                            className={filter === 'pending' ? 'active' : ''}
                            onClick={() => setFilter('pending')}
                        >
                            Bekleyen
                        </button>
                        <button
                            className={filter === 'confirmed' ? 'active' : ''}
                            onClick={() => setFilter('confirmed')}
                        >
                            Onaylı
                        </button>
                        <button
                            className={filter === 'completed' ? 'active' : ''}
                            onClick={() => setFilter('completed')}
                        >
                            Tamamlandı
                        </button>
                    </div>
                </div>

                <div className="reservations-table">
                    {reservations.length === 0 ? (
                        <p className="no-data">Rezervasyon bulunamadı</p>
                    ) : (
                        <table>
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Müşteri</th>
                                    <th>Telefon</th>
                                    <th>Araç</th>
                                    <th>Nereden</th>
                                    <th>Nereye</th>
                                    <th>Tarih</th>
                                    <th>Tip</th>
                                    <th>Saat</th>
                                    <th>Süre</th>

                                    <th>Durum</th>
                                    <th>İşlemler</th>
                                </tr>
                            </thead>
                            <tbody>
                                {reservations.map(reservation => {
                                    const statusInfo = getStatusBadge(reservation.status);
                                    const rentalType = reservation.rental_type || 'hourly';
                                    return (
                                        <tr key={reservation.id}>
                                            <td>#{reservation.id}</td>
                                            <td>
                                                <div className="customer-info">
                                                    <strong>{reservation.customer_name}</strong>
                                                    <small>{reservation.customer_email}</small>
                                                </div>
                                            </td>
                                            <td>{reservation.customer_phone}</td>
                                            <td>{reservation.vehicle_name}</td>
                                            <td>{reservation.pickup_location}</td>
                                            <td>{reservation.dropoff_location}</td>
                                            <td>{formatDate(reservation.reservation_date)}</td>
                                            <td>
                                                <span className={`type-badge ${rentalType}`}>
                                                    {rentalType === 'hourly' ? '⏰ Saatlik' : '📅 Günlük'}
                                                </span>
                                            </td>
                                            <td>{rentalType === 'hourly' ? `${reservation.start_hour}:00` : 'Tüm gün'}</td>
                                            <td>
                                                {rentalType === 'hourly'
                                                    ? `${reservation.duration_hours} saat`
                                                    : `${reservation.duration_hours} gün`}
                                            </td>

                                            <td>
                                                <select
                                                    value={reservation.status}
                                                    onChange={(e) => handleStatusChange(reservation.id, e.target.value)}
                                                    className={`status-select ${statusInfo.class}`}
                                                >
                                                    <option value="pending">Bekliyor</option>
                                                    <option value="confirmed">Onaylandı</option>
                                                    <option value="completed">Tamamlandı</option>
                                                    <option value="cancelled">İptal</option>
                                                </select>
                                            </td>
                                            <td className="actions">
                                                <button
                                                    onClick={() => handleDelete(reservation.id)}
                                                    className="btn-delete"
                                                >
                                                    Sil
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AdminReservations;
